import React, { useEffect, useState } from 'react';
import Navbar from './Features/Navbar';
import hr from '../images/icons/hr.png';
import { Box, CircularProgress, Container } from '@mui/material';
import Footer from './Home/Footer';
import { Fade } from 'react-awesome-reveal';
import { Link } from 'react-router-dom';
import StrapiRichText from './StrapiRichText';
import { fetchStrapiSingleType } from '../services/strapiClient';
import { pickCmsText, pickCmsTitle } from '../utils/cmsContent';

const richTextSx = {
  fontSize: '20px',
  lineHeight: 1.8,
  fontFamily: 'Montserrat',
  color: '#2f3036',
  fontWeight: 500,
  '& p': { marginTop: 0, marginBottom: '1rem' },
  '& p:last-child': { marginBottom: 0 },
  '& ul, & ol': { marginBottom: '1rem', paddingLeft: '1.25rem' },
  '& ul ul': { marginTop: '0.5rem', marginBottom: '0.5rem' },
  '& li': { marginBottom: '0.35rem' },
  '& strong': { fontWeight: 700 },
  '& a': { color: '#1398aa' },
  '& u': { textDecoration: 'underline', fontStyle: 'italic' },
  '& h2': {
    fontFamily: 'Montserrat',
    lineHeight: 1.8,
    fontSize: '34px',
    marginBottom: '1rem',
    marginTop: '1rem',
    fontWeight: 700,
    color: '#2f3036',
  },
  '& h3': {
    fontFamily: 'Montserrat',
    lineHeight: 1.8,
    fontSize: '28px',
    marginBottom: '1rem',
    marginTop: '1rem',
    fontWeight: 700,
    color: '#2f3036',
  },
  '& .service-callout': {
    borderStyle: 'solid',
    borderRadius: '20px',
    backgroundColor: '#EBEAFF',
    borderColor: '#EBEAFF',
    marginBottom: '3rem',
    padding: '20px',
    fontFamily: 'Montserrat',
    lineHeight: 1.8,
    fontSize: '20px',
    color: '#2f3036',
    fontWeight: 600,
  },
  '& .service-callout p': { marginTop: 0, marginBottom: '1rem' },
  '& .service-callout p:last-child': { marginBottom: 0 },
};

function normalizeRich(value) {
  if (value == null) return null;
  const s = String(value).trim();
  return s.length > 0 ? s : null;
}

export default function AchGadolPageShell({
  strapiApiId = 'page-ach-gadol',
  defaultTitle = 'Ach Gadol',
  defaultDonationLine = "Pour soutenir les soldats seuls via l'association Ach Gadol, cliquez ICI.",
  StaticFallback,
  fadeTriggerOnce = true,
}) {
  const [title, setTitle] = useState(defaultTitle);
  const [donationLine, setDonationLine] = useState(defaultDonationLine);
  const [body, setBody] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = `${title} | Tsahal Connection`;
  }, [title]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const attrs = await fetchStrapiSingleType(strapiApiId);
        if (cancelled) return;
        if (attrs) {
          setTitle(pickCmsTitle(attrs.title, defaultTitle));
          setDonationLine(pickCmsText(attrs.donationLine, defaultDonationLine));
          setBody(normalizeRich(attrs.body));
        } else {
          setTitle(defaultTitle);
          setDonationLine(defaultDonationLine);
          setBody(null);
        }
      } catch {
        if (!cancelled) {
          setTitle(defaultTitle);
          setDonationLine(defaultDonationLine);
          setBody(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [strapiApiId, defaultTitle, defaultDonationLine]);

  if (loading) {
    return (
      <div>
        <Navbar />
        <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: '40vh', alignItems: 'center' }}>
          <CircularProgress sx={{ color: '#1398aa' }} />
        </Box>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <Fade triggerOnce={fadeTriggerOnce}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginTop: '2rem' }}>
          <h1 style={{ fontFamily: 'Montserrat', fontWeight: '700', textAlign: 'center' }}>{title}</h1>
          <img src={hr} alt="" width="80" height="50" />
          <h2 style={{ fontFamily: 'Montserrat', fontSize: '25px', fontWeight: '600', textAlign: 'center', marginTop: '2rem' }}>
            {donationLine.includes('ICI') ? (
              <>
                {donationLine.replace('ICI', '')}
                <Link target="_blank" to="https://achgadol.org/en/donation/" style={{ color: 'black' }}>ICI</Link>
                .
              </>
            ) : (
              donationLine
            )}
          </h2>
        </div>

        {body ? (
          <Container maxWidth="md" style={{ marginTop: '3rem', marginBottom: '3rem' }}>
            <StrapiRichText source={body} sx={richTextSx} />
          </Container>
        ) : (
          <StaticFallback />
        )}

        <Footer />
      </Fade>
    </div>
  );
}
